class CroFlexBadge extends HTMLElement {
  #dialog = null;
  #opener = null;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    this.#opener = this.querySelector('[data-flex-open]');
    if (!this.#dialog || !this.#opener) return;
    this.#opener.addEventListener('click', this.#open);
    this.#dialog.addEventListener('click', this.#onDialogClick);
    this.#dialog.addEventListener('keydown', this.#onKeydown);
    this.#dialog.addEventListener('close', this.#onClose);
  }

  disconnectedCallback() {
    this.#opener?.removeEventListener('click', this.#open);
    this.#dialog?.removeEventListener('click', this.#onDialogClick);
    this.#dialog?.removeEventListener('keydown', this.#onKeydown);
    this.#dialog?.removeEventListener('close', this.#onClose);
  }

  #open = () => {
    this.#dialog.showModal();
    this.#opener.setAttribute('aria-expanded', 'true');
  };

  #onDialogClick = (event) => {
    if (event.target.closest('[data-flex-close]')) return this.#dialog.close();
    if (event.target !== this.#dialog) return;
    const box = this.#dialog.getBoundingClientRect();
    const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
    if (!inside) this.#dialog.close();
  };

  #onKeydown = (event) => {
    if (event.key === 'Escape') this.#dialog.close();
  };

  #onClose = () => {
    this.#opener.setAttribute('aria-expanded', 'false');
    this.#opener.focus();
  };
}

if (!customElements.get('cro-flex-badge')) customElements.define('cro-flex-badge', CroFlexBadge);
